module.exports = __webpack_public_path__ + "static/media/email.b4dfb6e3.svg";